import { CodeBlock } from '@ui/pages/onboarding/components/configuration/CodeBlock'

import { ConfigurationProps } from './types'

export const DatadogConfiguration = ({ instanceUrl }: ConfigurationProps) => (
  <>
    <h2 className="my-4 text-2xl font-bold">Datadog</h2>

    <p className="my-4 text-gray-500">
      Datadog data can be sent to Datable by modifying the Datadog agent configuration, either in the configuration file
      or via an environment variable.
    </p>

    <h3 className="my-4 text-xl font-bold">Environment variables:</h3>

    <CodeBlock
      code={`
DD_LOGS_CONFIG_DD_URL: ${instanceUrl}:5301
DD_APM_DD_URL: ${instanceUrl}:5301
`}
    />

    <h3 className="my-4 text-xl font-bold">YAML configuration:</h3>

    <p className="my-4 text-gray-500">
      To configure these settings in the Datadog agent configuration file, add/modify the following values, ensuring
      that any parent keys are also uncommented and not duplicated.
    </p>

    <CodeBlock
      code={`
logs_config:
  logs_dd_url: ${instanceUrl}:5301
  use_http: true
apm_config:
  apm_dd_url: ${instanceUrl}:5301
`}
    />
  </>
)
